const API_BASE_URL = process.env.NODE_ENV === "production" ? "https://api.kka-studio.com/" : "https://localhost:44351/";

export class ApiClient {
    public static async isSignIn() {
        try {
            await ApiClient.get("v1/auth/validate");
            return true;
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    public static async sendActivationCode(code: string) {
        try {
            await ApiClient.post("v1/app/msl/activation/active", {
                "activateCode": code
            });
            return true;
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    public static getSignInGoogleUrl() {
        return `${API_BASE_URL}v1/auth/google/login?useDeepLink=true&bundleName=com.kkastudio.activation`;
    }

    public static getSignInAppleUrl() {
        return `${API_BASE_URL}v1/auth/apple/login?useDeepLink=true&bundleName=com.kkastudio.activation`;
    }

    public static getSignOutUrl() {
        return `${API_BASE_URL}v1/auth/logout?useDeepLink=true&bundleName=com.kkastudio.activation.signout`;
    }

    private static async get(path: string) {
        return await ApiClient.request("GET", path, null);
    }

    private static async post(path: string, body: any) {
        return await ApiClient.request("POST", path, body);
    }

    private static async request(method: "GET"|"POST", path: string, data?: any) {
        const headers = {
            "Content-Type": "application/json",
        };

        let body: string = null;
        if (data != null) {
            body = JSON.stringify(data);
        }

        try {
            const response = await fetch(`${API_BASE_URL}${path}`, {
                credentials: "include",
                mode: "cors",
                method,
                headers,
                body
            });

            const text = await response.text();
            let data = null;
            if (text) {
                data = JSON.parse(text);
            }

            if (!response.ok) {
                throw { status: response.status, data };
            }

            return data;
        } catch (error) {
            throw error;
        }
    }
}